
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { AtividadeUpdateConcluida, AtividadeUpdateConcluidaResponse } from '../concluida';

@Injectable({
    providedIn: 'root'
})
export class AtividadeConcluidaHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/atividade`;
    }

    /** Realiza a atualização na atividade marcando a mesma como concluída ou não */
    updateConcluida(entity: AtividadeUpdateConcluida): Observable<AtividadeUpdateConcluidaResponse> {
        return this.customHttp.put<AtividadeUpdateConcluidaResponse>(`${this.pathApi}/${entity.id}/concluida`, entity);
    }
}
